export const Page = '/SitioPublico/Empresarios/Financiamiento/SimuladorTransversal/';
export const Category = 'Empresario Publico - Simulador Transversal';

export const GtmInteractiveKeys = {
	category: 'evento-interactivo-categoria',
	action: 'evento-interactivo-accion',
	label: 'evento-interactivo-etiqueta',
} as const;

export const GtmEvents = {
	pageVirtual: 'pagina-virtual',
	interactive: 'evento-interactivo',
} as const;

export const EventType = {
	click: 'Click',
	modal: 'Modal',
	snackbar: 'Snackbar',
};

export const PathPages = {
	companyData: 'DatosEmpresa',
	dataValidation: 'ValidacionDatos',
	error: 'Error',
	bciClientError: 'SimulacionNoDisponible',
	genericProblem: 'ProblemaCarga',
	VerificationProblem: 'ProblemaVerificacion',

	leak: 'ModalFuga',
};

export const Subcategories = {
	companyData: 'Datos Empresa',
	dataValidation: 'Validacion Datos',
	error: 'Error',
	bciClient: 'Simulacion No Disponible',
	genericProblem: 'Problema Carga',
	VerificationProblem: 'Problema Verificacion',
	leakModal: 'Modal Fuga',
	message: 'Mensaje',
	incorrectCode: 'Codigo Incorrecto',
	resendCode: 'Codigo Reenviado Con Exito',
	expiredCode: 'Agoto Tiempo Espera Codigo',
};

export const LabelsEvents = {
	incorrectCode: 'codigo incorrecto',
	forwardedCode: 'codigo reenviado con exito',
	expiredCode: 'agoto tiempo espera codigo',
	resendCode: 'reenviar codigo',
	editPhone: 'editar numero telefono',
	update: 'actualizar',
	goHome: 'ir al inicio',
	understood: 'entendido',
	continue: 'continuar',
	simulation: 'simulacion',
	goOut: 'salir',
	contact: 'contacta ejecutivo y hazte cliente',
};
